import { Component, OnInit } from '@angular/core';
import { PalletService } from '../services/pallet.service';
import { ClientsService } from '../services/clients.service';

import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
@Component({
  selector: 'app-pallet',
  templateUrl: './pallet.component.html',
  styleUrls: ['./pallet.component.css']
})
export class PalletComponent implements OnInit {
  palletIdList;
  palletNumber: string;
  pallet;
  selectPallet = false;
  palletSelected = false;
  palletsWithLike = false;
  pictureLinks;
  like;
  palletsLike;
  startDate;
  endDate;
  whseClients;
  selClient = 0;
  subClients;
  selSubClient = 0;
  shipped = 'N';
  arrived = 'Y';
  advLike;
  csvArrayToReturn = [];
  csvOptions;
  advPostData = {startdate: '',  enddate: '' , shipped: '' ,
                  clientid: 0, subclientid: 0, like: '',
                  querynum: 0 };



  constructor(private palletService: PalletService,
              private clientService: ClientsService) { }

  ngOnInit() {
    this.startDate = this.setStartDate();
    this.endDate =  this.setEndDate();
    this.getWhseClients();
  }

  getLikeList() {
    console.log(this.palletNumber);
    // code to use pallet service to return a list of like pallets
    this.palletService.getLikepalletid(this.palletNumber)
   .then(palletlist => {
     this.palletIdList = palletlist;
     this.selectPallet = true;
     this.palletSelected = false;
     this.palletsWithLike = false;
   })
   .catch(err => console.log(err));
   }

   onPalletSelect(palletid) {
    this.palletNumber = palletid;
    // get pallet info
    this.palletService.getSelectedpallet(this.palletNumber)
    .then(pallet => {
      this.pallet = pallet;
      console.log(this.pallet);
      this.getPictureLinks(this.pallet.palletid);
      this.selectPallet = false;
      this.palletSelected = true;
      this.palletsWithLike = false;
      this.palletNumber = '';
    })
    .catch(err => console.log(err));
   }

   getPictureLinks(palletid) {
     // get the picture links for this pallet selected
     this.palletService.getPictureLinks(palletid)
     .then(links => {
       console.log(links);
      this.pictureLinks = links;
     })
     .catch(err => console.log(err));
   }

   getPalletsLike() {
    this.cleanUpForm();
    // get the list of pallets with like in the description
    if(this.like.length > 1) {
      this.palletService.getPalletsLike(this.like)
      .then(palletList => {

       this.palletsLike = palletList;
       console.log(this.palletsLike)
       this.selectPallet = false;
       this.palletSelected = false;
       this.palletsWithLike = true;
      })
      .catch(err => console.log(err));
    }

  }
  // capture change on advanced serach and build Query
  advChange() {
    let whereQuery: string;
    console.log( 'Advance Search Change OVERALL' );
    if (this.selClient === 0) {
      whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
      AND shipped = '${this.shipped}' `;
      console.log (whereQuery)
    } else if (this.selClient >= 0 && this.selSubClient === 0) {
      whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
      AND shipped = '${this.shipped}' AND clientid = ${this.selClient}`;
      console.log (whereQuery)
    } else if (this.selClient >= 0 && this.selSubClient >= 0) {
      whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
      AND shipped = '${this.shipped}' AND subclientid = ${this.selSubClient}`;
      console.log (whereQuery)
    }

    this.palletService.getAdvPalletQry2(whereQuery)
    .then((palletList) => {
      this.palletsLike = palletList;
    });


  }

  // capture keyup and build query special for like
  advChangeKeyup() {
    if (this.advLike.length > 1) {
      console.log(this.advLike);
      let whereQuery: string;
      if (this.selClient === 0) {
        whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
        AND shipped = '${this.shipped}' AND description LIKE '%${this.advLike}%' `;
        console.log (whereQuery)
      } else if (this.selClient >= 0 && this.selSubClient === 0) {
        whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
        AND shipped = '${this.shipped}' AND clientid = ${this.selClient} AND description LIKE '%${this.advLike}%'`;
        console.log (whereQuery)
      } else if (this.selClient >= 0 && this.selSubClient >= 0) {
        whereQuery = `activateddate BETWEEN CAST('${this.startDate}' AS DATE) AND CAST('${this.endDate}' AS DATE)
        AND shipped = '${this.shipped}' AND subclientid = ${this.selSubClient} AND description LIKE '%${this.advLike}%'`;
        console.log (whereQuery)
      }
      this.palletService.getAdvPalletQry2(whereQuery)
      .then((palletList) => {
        this.palletsLike = palletList;
      });
    }
  }

  getWhseClients() {
    this.clientService.getWhseClients()
    .then( (clients) => {
      this.whseClients = clients;
    });
  }

  onClientSelected() {
    this.cleanUpForm();
    // client selected now check to see if all or there are subclients
    this.subClients = null; // clear out subClients
    this.selSubClient = 0;
    if (this.selClient > 0 || this.selClient !== 0) {
      this.clientService.getSubClients(this.selClient)
      .then ( (subclients) => {
        console.log(subclients)
        if (subclients.length > 1) {
          this.subClients = subclients;
        }
      });
    }
  }

  getAdvPallets(qryNum) {
    this.palletSelected = false;
  }

  onSubClientSelected() {
    this.cleanUpForm();
  }
  onSubClientBtn() {
    this.cleanUpForm();
  }

  onSelArrived() {
    // radio btn arrived changed
    // if (this.arrived === 'N') {
    //   this.startDate = '2019-01-01' // set to before pallets came in
    // }
    console.log('Radio arrived changed')
  }

  onSelShipped() {
    // radio btn shipped changed
    console.log('Radio Shipped changed')
  }

  // create json for csv conversion on pallet data
  async convertPalletArray () {
    for (const pallet of this.palletsLike) {
      await this.buildPalletArray(pallet);
    }
    // set csv file options
    this.csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Pallet Filter CSV :',
      useBom: true,
      noDownload: false,
      headers: ["Pallet", "BolIn", "Client", "Description", "SubClient",
                "BolOut", "DateOut", "NoteOut", "Length", "Width", "Height", "Weight", "DimWt", "Size", "Shipped", "DateIn"]
    };
    console.log(this.csvArrayToReturn);
    const toCsv = JSON.stringify(this.csvArrayToReturn);
    // create the csv file for download
    new AngularCsv(toCsv, 'FilteredPallets', this.csvOptions);

  }

  async buildPalletArray(pallet) {
    const palletObj = { Pallet: pallet.palletid, BolIn:
      pallet.bolqtid, Client: pallet.client,
      Description: pallet.description, SubClient: pallet.subclient,
      BolOut: pallet.bolout, DateOut: pallet.dateout,
      NoteOut: pallet.noteout, Length:pallet.L, Width: pallet.W, Height: pallet.H, Weight: pallet.wt,
      DimWt: pallet.dimwt, Size: pallet.size, Shipped: pallet.shipped, DateIn: pallet.timestamp
      };

      this.csvArrayToReturn.push(palletObj);
  }



  cleanUpForm() {
    // cleanup values when a selection changes
    this.palletSelected = false;
    this.advLike = '';
    this.palletsLike = [];

  }

  setStartDate() {
    const todaysDate = new Date();
    // set case logic  to minus 6 months from today for now
    todaysDate.setDate(todaysDate.getDate() - 180);
    return todaysDate.toISOString().slice(0, 10);
  }

  setEndDate() {
    const todaysDate = new Date();
    // set end date today
    return todaysDate.toISOString().slice(0, 10);
  }

}



// WEBPACK FOOTER //
// ./src/app/pallet/pallet.component.ts